import { CustomAccordion } from "./CustomAccordion";

export default CustomAccordion;